import { render, staticRenderFns } from "./EstoqueSeguranca.vue?vue&type=template&id=608225c4"
import script from "./EstoqueSeguranca.vue?vue&type=script&lang=js"
export * from "./EstoqueSeguranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports